"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encoder = exports.decoder = exports.revocable = exports.Revocable = exports.vaultStoreUUID = exports.keyStoreUUID = exports.uuidNamespace = exports.performance = exports.setPerformance = exports.crypto = exports.setCrypto = void 0;
const native = __importStar(require("@shapeshiftoss/hdwallet-native"));
const uuid = __importStar(require("uuid"));
const web_encoding_1 = require("web-encoding");
let cryptoResovler;
function setCrypto(x) {
    if (!x)
        throw new Error("crypto module is required");
    if (!cryptoResovler)
        throw new Error("can only set crypto module once");
    cryptoResovler(x);
    cryptoResovler = undefined;
}
exports.setCrypto = setCrypto;
exports.crypto = new Promise(resolve => cryptoResovler = resolve);
let performanceResolver;
function setPerformance(x) {
    if (!x)
        throw new Error("performance module is required");
    if (!performanceResolver)
        throw new Error("can only set performance module once");
    performanceResolver(x);
    performanceResolver = undefined;
}
exports.setPerformance = setPerformance;
exports.performance = new Promise(resolve => performanceResolver = resolve);
exports.uuidNamespace = uuid.v5("hdwallet-native-vault", uuid.NIL);
exports.keyStoreUUID = uuid.v5("keyStore", exports.uuidNamespace);
exports.vaultStoreUUID = uuid.v5("vaultStore", exports.uuidNamespace);
exports.Revocable = native.crypto.Isolation.Engines.Default.Revocable;
exports.revocable = native.crypto.Isolation.Engines.Default.revocable;
exports.decoder = new web_encoding_1.TextDecoder();
exports.encoder = new web_encoding_1.TextEncoder();
